import { Trans, useTranslation } from 'react-i18next'
import { cn } from 'src/utils/cx'
import { STEP_ICONS } from '../constants'
import css from '../Landing.module.css'
import { useFadeUp } from './useFadeUp'

export default function StepsSection() {
  const { t } = useTranslation('blackboard', { keyPrefix: 'welcome' })
  const fadeRef = useFadeUp()

  return (
    <section
      id="steps"
      className="py-24"
      style={{ background: 'var(--landing-pink-bg2)' }}
    >
      <div className="mx-auto max-w-[1200px] px-6">
        <div ref={fadeRef} className={cn(css.fadeUp)}>
          <div className="mb-2 text-sm font-bold uppercase tracking-wider text-[--landing-pink]">
            {t('steps.section-label')}
          </div>
          <h2 className="mb-4 text-4xl font-semibold leading-tight text-gray-900">
            <Trans
              i18nKey="blackboard:welcome.steps.heading"
              components={{
                highlight: <span className={css.gradientText} />,
              }}
            />
          </h2>
          <p className="max-w-[600px] text-base text-gray-500">
            {t('steps.subheading')}
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {STEP_ICONS.map((Icon, i) => (
            <div
              key={i}
              className="rounded-3xl border-[1.5px] border-gray-200 bg-white p-9 text-center transition-all hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(255,131,184,0.08)]"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="mx-auto mb-5 flex h-[52px] w-[52px] items-center justify-center rounded-2xl bg-gradient-to-br from-[#FF83B8] to-[#FF5A9E] text-xl font-semibold text-white">
                {i + 1}
              </div>
              <h3 className="mb-2.5 text-lg font-bold">
                {t(`steps.items.${i}.title`)}
              </h3>
              <p className="text-sm text-gray-500">
                {t(`steps.items.${i}.desc`)}
              </p>
              <div className="mt-5 flex h-[120px] items-center justify-center rounded-2xl bg-[--landing-pink-bg]">
                <Icon className="size-10 text-[--landing-pink]" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
